import * as actionInventory from '../actions/inventoryAction';
import { translate, showMessageToastCustom, getUrlInventoryApi, getApiKeyLogistics, parseParams } from '../utils/util';
import { startLoading, endLoading } from '../actions/loadingAction';
import HttpService from './HttpService';

const httpService = new HttpService(getUrlInventoryApi(window), getApiKeyLogistics(window));

export default class InventoryService {
    static getInventories(vision, typeInventory, pagination) {
        return (dispatch) => {
            const filter = {};
            filter.typeInventory = typeInventory;
            Object.assign(filter, pagination);
            const url = '/inventory';
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: 300000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        if (dados && dados?.items) {
                            dispatch(actionInventory.resetLots());
                            dispatch(actionInventory.listInventories(dados));
                        }
                    }
                }).catch((error) => {
                    dispatch(endLoading());

                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getInventoryCodes(typeInventory, callback) {
        return (dispatch) => {
            const filter = {};
            filter.typeInventory = typeInventory;
            Object.assign(filter);
            const url = '/inventory/codes';
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: 300000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        if (dados) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getLots(vision, filter, pagination) {
        const url = '/inventory/lot';
        pagination.PageSize = 20;
        Object.assign(filter, pagination);

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        if (dados && dados?.items) {
                            dispatch(actionInventory.setLots(dados));
                        }
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getRangeQrCode(inventoryId, callback) {
        const url = `/inventory/qrcoderange/${inventoryId}`
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        callback(response.data.data)
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                dispatch(endLoading());
            }
        };
    }

    static getLotsByRange(inventoryId, inicialLot, finalLot) {
        const url = `/inventory/lot/range?inventoryId=${inventoryId}
            &inicialLot=${inicialLot}&finalLot=${finalLot}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionInventory.setLots(response.data));
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                dispatch(endLoading());
            }
        };
    }

    static getLotItems(vision, filter, pagination) {
        pagination.PageSize = 20;
        Object.assign(filter, pagination);

        const url = '/inventory/lot/items';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        if (dados && dados?.items) {
                            dispatch(actionInventory.setLotItems(dados));
                        }
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getLotItem(lotItemId, vision) {
        const url = `/inventory/lot/item/${lotItemId}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionInventory.selectLotItem(response.data.data));
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getAuditItem(filter, callback) {
        const url = '/inventory/audit/item';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                dispatch(endLoading());
            }
        };
    }

    static refreshInventory = (filter, callback) => {
        return (dispatch) => {
            const url = '/inventory/refresh';
            if (navigator.onLine) {
                try {
                    dispatch(startLoading());
                    httpService.instance.put(url, filter, { timeout: 300000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response.status === 200) {
                            showMessageToastCustom(translate('warning', 'general'), response.data.message, 8000, 'mdi mdi-information-outline blue-text');
                            if (callback) callback();
                        } else {
                            showMessageToastCustom(translate('warning', 'general'), response.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                        }
                    });
                } catch (error) {
                    showMessageToastCustom(translate('warning', 'general'), error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                } finally {
                    dispatch(endLoading());
                }
            }
        };
    }

    static refreshLots = (filter, showLoading) => {
        return (dispatch) => {
            const url = '/inventory/lot/refresh';
            if (navigator.onLine) {
                try {
                    if (showLoading) {
                        dispatch(startLoading());
                    }

                    httpService.instance.put(url, filter, { timeout: 300000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response.status !== 200) {
                            showMessageToastCustom(translate('warning', 'general'), response.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                        } else {
                            showMessageToastCustom(translate('warning', 'general'), translate('lot-processing', 'inventory'), 8000, 'mdi mdi-alert-circle-outline blue-text');
                        }
                    });
                } catch (error) {
                    showMessageToastCustom(translate('warning', 'general'), error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                } finally {
                    if (showLoading) dispatch(endLoading());
                }
            }
        };
    }

    static refreshGeneralInventoryLot = (lot) => {
        return (dispatch) => {
            dispatch(actionInventory.refreshLot(lot));
        };
    }

    static refreshGeneralInventoryStatus = (inventoryId, status) => {
        return (dispatch) => {
            dispatch(actionInventory.refreshInventoryStatus(inventoryId, status));
        };
    }

    static refreshGeneralInventory = (inventory) => {
        return (dispatch) => {
            dispatch(actionInventory.refreshInventory(inventory));
        };
    }

    static refreshInventoryLotItemReading = (lotItem) => {
        return (dispatch) => {
            dispatch(actionInventory.addListLotItemsReading(lotItem));
            //dispatch(actionInventory.updateLotItemStatus(lotItem));
        };
    }

    static changeUserLots = (newUser, initialLot, finalLot, lotOriginId, inventoryId, callback) => {
        const url = '/inventory/lot/changeuser';
        const filter = { newUser, initialLot, finalLot, lotOriginId, inventoryId };
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, filter, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) callback();
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }
    static changeUserSecondCount = (filter, callback) => {
        const url = '/inventory/lot/secondcount/changeUser';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, filter, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) callback();
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static unblockUserLots = (lotNumber, callback) => {
        const url = `/inventory/lot/unblock/${lotNumber}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, lotNumber, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) callback();
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static sendLotItemSIM = (lotItem, vision, callback) => {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post('/inventory/lot/items/sendlotitemsim', lotItem,
                    { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response.status === 200 && callback) {
                            callback(response.data.data);
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    static checkCloseLot = (lotItem, vision, callback) => {
        const url = '/inventory/lot/items/checkcloselot';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, lotItem, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        }
    }

    static readingLotItem = (lotItem, quantity, vision, callback) => {
        const url = '/inventory/lot/items/reading';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                Object.assign(lotItem, { quantity });
                httpService.instance.post(url, lotItem, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionInventory.updateLotItemStatus(response.data.data));
                        if (callback) {
                            callback(response.data.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getItemsReading(filter) {
        const url = '/inventory/lot/items/reading';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionInventory.setListLotItemsReading(response.data.data));
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getLotItemsReading(filter, pagination, callback) {
        if (pagination) {
            pagination.PageSize = 20;
        }

        Object.assign(filter, pagination);
        const url = '/inventory/lot/reading';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionInventory.setLotItemsReading(response.data.data));
                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static rowHeaderReport = (inventoryId, location, callback) => {
        const parameter = { InventoryId: inventoryId, Location: location };
        const url = '/inventory/rowheaderreport';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, parameter).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getBytesItemsReading(filter, callback) {
        Object.assign(filter);

        const url = '/inventory/lot/items/file';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static live(callback) {
        const url = '/live';
        return () => {
            if (navigator.onLine) {
                httpService.instance.get(url).then((response) => {
                    callback(response);
                }).catch((error) => {
                    callback(error);
                })
            }
        };
    }

    static getReport(filter, callback) {
        const url = '/inventory/report';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static readingLotItemClosed = (lotItem, quantity, qrCode, vision, callback) => {
        let reading = {};
        reading.lotItemId = lotItem.lotItemId;
        reading.quantity = quantity;
        reading.validationCode = qrCode;
        reading.lotId = lotItem.lotId;
        reading.inventoryId = lotItem.lot.inventoryId;
        const url = '/inventory/lot/items/readingclosed';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                Object.assign(lotItem, { quantity });
                httpService.instance.post(url, reading, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionInventory.updateLotItemStatus(response.data.data));
                        if (callback) {
                            callback(response.data.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static updateQrCodeRange = (data, callback) => {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post('/inventory/qrcoderange', data,
                    { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response.status === 200 && callback) {
                            callback(response.data.data);
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    static getPartNumberValidate(inventoryId, partNumberCode, callback) {
        const url = 'inventory/partnumber';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: { inventoryId, partNumberCode } }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    callback();
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                dispatch(endLoading());
            }
        };
    }


    static getBalaceData(inventoryId, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                // dispatch(startLoading());
                let url = `/balance?inventoryId=${inventoryId}`;
                httpService.instance.get(url,
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response && response.data) {
                            dispatch(actionInventory.setBalanceData(response.data.data));
                            if (callback) {
                                callback(response.data.data);
                            }
                        }
                    }).catch((error) => {
                        console.log(error.response?.data?.message || error.message || error);
                        // showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        // dispatch(endLoading());
                    });
            }
        };
    }


    static adjustLotItem = (model, callback) => {
        const url = '/inventory/lotitem/adjust';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, model, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {

                        if (callback) callback();
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getLogs(filter, callback) {
        const url = '/log';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url,
                    {
                        params: filter
                    }).then((response) => {
                        if (response.status === 200) {
                            dispatch(actionInventory.setLogs(response.data?.data));
                            if (callback) {
                                callback(response.data.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static forceSendAllSIM(callback) {
        const url = '/inventory/forceall';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.patch(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status !== 200) {
                        showMessageToastCustom(translate('warning', 'general'), response.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), "Em processamento...", 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    }
                    if (callback) {
                        callback();
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }
    static forceSendSIM(logId, callback) {
        var filter = {};
        filter.id = logId;
        const url = '/inventory/force';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.patch(url, filter, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status !== 200) {
                        showMessageToastCustom(translate('warning', 'general'), response.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), "Em processamento...", 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    }
                    if (callback) {
                        callback();
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getLotsByUser(filter, callback) {
        const url = `/inventory/lot/getfilterlotsbyuser`;

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter, paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout')
                }
                ).then((response) => {

                    if (response.status === 200) {
                        const dados = response.data.data;
                        if (dados && callback) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getAdvancedLotItems(vision, filter, pagination) {
        pagination.PageSize = 300;
        Object.assign(filter, pagination);

        const url = '/inventory/lot/advanced';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter, paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }, timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout')
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        if (dados && dados?.items) {
                            dispatch(actionInventory.setLotItems(dados));
                        }
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

}
